import _ from 'lodash';
import React, {Component} from 'react';
import moment from 'moment';
import {
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
  Card,
  CardTitle,
  CardText,
  LinearProgress,
  TablePagination,
  Grid,
  Cell,
  Button,
} from 'react-md';

import loanService from './../../../services/loan';
import { baseUrl } from './../../../services/endpoints';

import DefaultLayout from './../../../components/layouts/default';
import LineChart from './../../../components/molecules/charts/lineChart';
import TableActions from './../../../components/molecules/tableActions';
import ReportsNav from './../../../components/atoms/subNavs/reportsNav';
import Workbook from "react-excel-workbook";
import FlatOrIconButton from "../../../components/atoms/flatOrIconButton";
import {optionsGET, session} from "../../../services/options";

class userReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      excelData: [],
      data: null,
      loading: false,
      slicedData: null,
      loan: {
        data: null,
        loading: false,
        total: 0,
      },
    };

    this.getData = this.getData.bind(this);
    this.getLoan = this.getLoan.bind(this);
    this.handlePagination = this.handlePagination.bind(this);
  }

  handlePagination(start, rowsPerPage) {
    this.setState({
      slicedData: this.state.data.slice(start, start + rowsPerPage)
    });
  };

  async componentWillMount() {
  }

  async componentDidMount() {
    await this.getData();
    await this.getLoan('month');
  }

  getLoan(type) {
    this.setState({
      loan: {
        ...this.state.loan,
        loading: true,
      },
    });

    //return loanService.generalReportsLoan({type})
    //return fetch(`http://52.14.65.118:4000/general_report_loans/?type=${type}&report=user`, optionsGET())
    return fetch(`${baseUrl}general_report_loans/?type=${type}&report=user`, optionsGET())
    .then(response => response.json())
      .then(response => {
        console.log(response)
        let data = response
          .filter(({result}) => !/error/ig.test(result))
          .sort((prev, next) => {
            if (moment(prev.trace_date) < moment(next.trace_date)) return -1;
            if (moment(prev.trace_date) > moment(next.trace_date)) return 1;
            return 0;
          });

        this.setState({
          loan: {
            loading: false,
            data,
            total: data.reduce((total, element) => {
              return total + element.count;
            }, 0),
          },
        });
      });
  }

  async getData() {
    this.setState({
      loading: true,
    });

    function formatDate(date) {
      const startWithYear = /^[0-9]{4}/.test(date);
      const newDate = startWithYear ? date.slice(0, 10).split('-') : date.slice(0, 10).split('/');
      const hour = date.slice(11,);
      const day = startWithYear ? newDate[2] : newDate[0];
      const month = newDate[1];
      const year = startWithYear ? newDate[0] : newDate[2];

      //  console.log(date)
      //  console.log(`${day}-${month}-${year} / ${hour}`)

      return `${day}/${month}/${year} ${hour}`;
    }

    //return await fetch('http://52.14.65.118:4000/user_traces/?user_type=M&start_at=2018-09-17', {
    return await fetch(baseUrl + 'user_traces/?user_type=M&start_at=2018-09-17', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.jwt}`,
      },
    })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(response.statusText);
        }
        return response.json();
      })
      .then(response => {
        //  const maxItemsRequest = 999;

        const excelData = response
          .filter(({result}) => !/error/ig.test(result))
          .map(({username, operation, barcode, result, data, inserted_at}) => ({
            username,
            operation,
            barcode,
            result,
            data: data ? formatDate(data) : data,
            inserted_at: inserted_at ? formatDate(inserted_at) : inserted_at,
          }))
          .sort((prev, next) => {
            if (moment(prev.inserted_at) < moment(next.inserted_at)) return -1;
            if (moment(prev.inserted_at) > moment(next.inserted_at)) return 1;
            return 0;
          });

        let data = response
          .filter(({result}) => !/error/ig.test(result))
          //  .slice(0, maxItemsRequest) // Reduce max length of the items that request
          .map(element => {
            let ref = {
              'Usuario': '',
              //  'Dispositivo': '',
              'Operación': '',
              'Código de barras': '',
              'Resultado': '',
              'Información': '',
              'Fecha': ''
            };

            if (element.username) ref = {...ref, 'Usuario': element.username};
            //  if (element.device && element.so) ref = (element.so || element.device) ? {...ref, 'Dispositivo': `${element.so} ${element.device}`} : {...ref, 'Dispositivo': 'Sin información'};
            if (element.operation) ref = {...ref, 'Operación': element.operation};
            if (element.barcode) ref = {...ref, 'Código de barras': element.barcode};
            if (element.result) ref = {...ref, 'Resultado': element.result};
            if (element.data) ref = {...ref, 'Información': formatDate(element.data)};
            if (element.inserted_at) ref = {...ref, 'Fecha': formatDate(element.inserted_at)};

            return ref;
          })
          .sort((prev, next) => {
            if (moment(prev.Fecha) < moment(next.Fecha)) return 1;
            if (moment(prev.Fecha) > moment(next.Fecha)) return -1;
            return 0;
          });

        //  _.sortBy(data, el => moment(el['Fecha']).unix());

        this.setState({
          excelData,
          data,
          slicedData: data.slice(0, 10),
          loading: false,
        });
      });
  }

  render() {
    return (
      <DefaultLayout>
        <Grid>
          <Cell size={12}>
            <ReportsNav/>
          </Cell>
          <Cell size='12'>
            <Card style={styles.card}>
              <CardTitle
                title={this.state.loan.total}
                subtitle='Usuarios'/>
              <CardText>
                {this.state.loan.loading && (
                  <LinearProgress id='loanProgress'/>
                )}
                {this.state.loan.data && (
                  <React.Fragment>
                    <hr/>
                    <Button
                      onClick={() => this.getLoan('day')}
                      flat
                      primary
                      swapTheming
                    >
                      Hoy
                    </Button>
                    <Button
                      style={{marginLeft: 10, marginRight: 10}}
                      onClick={() => this.getLoan('week')}
                      flat
                      primary
                      swapTheming
                    >
                      Últimos 7 días
                    </Button>
                    <Button
                      onClick={() => this.getLoan('month')}
                      flat
                      primary
                      swapTheming
                    >
                      Último mes
                    </Button>

                    <hr/>
                    <LineChart
                      width={600}
                      height={300}
                      data={this.state.loan.data}
                      dataKeyX='trace_date'
                      dataKeyY='count'
                    />
                  </React.Fragment>
                )}
              </CardText>
            </Card>

            <Card tableCard>
              <TableActions title='Usuarios activos' count={0} onResetClick={this.getData}/>
              <Workbook
                filename='Usuarios activos.xlsx'
                element={!this.state.loading
                  ? <Button
                    style={{marginLeft: 20}}
                    raised
                    primary
                    iconEl={<FlatOrIconButton
                      iconChildren='folder'
                      style={{color: '#fff'}}>»Exportar</FlatOrIconButton>}/>
                  : <Button
                    style={{marginLeft: 20}}
                    raised
                    primary
                    iconEl={<FlatOrIconButton
                      iconChildren='folder'
                      style={{color: '#fff'}}>Cargando...</FlatOrIconButton>}/>
                }>

                <Workbook.Sheet data={this.state.excelData} name='Reportes'>
                  <Workbook.Column
                    label='Usuario'
                    value='username'/>

                  <Workbook.Column
                    label='Operación'
                    value='operation'/>

                  <Workbook.Column
                    label='Código de barras'
                    value='barcode'/>

                  <Workbook.Column
                    label='Resultado'
                    value='result'/>

                  <Workbook.Column
                    label='Información'
                    value='data'/>

                  <Workbook.Column
                    label='Fecha'
                    value='inserted_at'/>

                </Workbook.Sheet>
              </Workbook>

              {this.state.loading && <LinearProgress id='usersProgress'/>}

              <DataTable baseId='dynamic-content-desserts'>
                {this.state.data && (
                  <React.Fragment>
                    <TableHeader>
                      <TableRow>
                        {Object.keys(this.state.data[0]).map(header => (
                          <TableColumn key={header}>{header}</TableColumn>
                        ))}
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {this.state.slicedData.map(item => (
                        <TableRow key={item.id}>
                          {Object.keys(item).map(key => (
                            <TableColumn key={key}>{item[key]}</TableColumn>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                    <TablePagination
                      rows={this.state.data.length}
                      rowsPerPageLabel='Registros por página'
                      onPagination={this.handlePagination}
                    />
                  </React.Fragment>
                )}
              </DataTable>
            </Card>
          </Cell>
        </Grid>
      </DefaultLayout>
    );
  }
}

const styles = {
  card: {
    borderRadius: '2px',
    marginBottom: '2rem',
  },
};


export default userReport;



// WEBPACK FOOTER //
// ./src/pages/home/reports/users.js